import { gql } from '@apollo/client';
/**
 * @const SignupAccountMutation
 * @since 1.0.0
 */
export const SignupAccountMutation = gql `
  mutation SignupAccountMutation($input: CreateAccountInput!) {
    createAccount(input: $input) {
      token
      startedAt
      expiresAt
    }
  }
`;
